import { setAIModelList } from '@flowus/common/ai-const';
import { useCallback, useEffect } from 'react';
import { request } from 'src/common/request';

export const useFetchAIModel = () => {
  return useCallback(() => {
    void request.ai.getModels.raw().then((res) => {
      if (res.code === 200) {
        const items = res.data.map((v) => {
          return { title: v.showName ?? '', value: v.value ?? '' };
        });
        setAIModelList(items);
      }
    });
  }, []);
};
